import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../consts/api";

export const useDeactivateSmartReaderCellular = () => {
  const res = useMutation((dto) =>
    http.post(
      HTTP_ENDPOINTS.posCardReader.deactivateSmartReaderCellular(),
      dto,
    ),
  );
  return res;
};
